import { Outlet } from "react-router";
import { EntrypointProvider } from "./infrastructure/entrypoint/EntryPointProvider";
import { KeepAliveIdP } from "./KeepAliveIdP/KeepAliveIdP";
import {
  getStatusPageData,
  KNOWN_COMPONENT_IDS,
  StatusPageBanner,
  StatusPageInfo,
} from "@digipost/statusbanner/dist/src";
import { useEffect, useState } from "react";
import { DocumentTitle } from "./DocumentTitle/DocumentTitle";
import {
  useAnalytics,
  usePageViewTracker,
} from "./infrastructure/analytics/functions";

function App() {
  const [statusList, setStatusList] = useState<StatusPageInfo[]>([]);

  usePageViewTracker();
  useAnalytics(true);

  useEffect(() => {
    getStatusPageData([
      KNOWN_COMPONENT_IDS.DIGIPOST_WEB,
      KNOWN_COMPONENT_IDS.SIGNERING_WEB,
    ]).then(setStatusList);
  }, []);

  return (
    <>
      <StatusPageBanner statusPageInfo={statusList} />
      <EntrypointProvider>
        <DocumentTitle />
        <Outlet />
        <KeepAliveIdP />
      </EntrypointProvider>
    </>
  );
}

export default App;
